import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=e5c89e5e&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"
import style0 from "./Detail.vue?vue&type=style&index=0&id=e5c89e5e&prod&lang=scss&scoped=true"
import style1 from "./Detail.vue?vue&type=style&index=1&id=e5c89e5e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5c89e5e",
  null
  
)

export default component.exports